const COMPANIONS=['mother','father','parents','spouse','guardian','other'];export default COMPANIONS;